// utils.js - graphql utils

import moment from 'moment-timezone'

export const generateAuthHeader = (token) => {
  return {headers: {authorization: token,
    'X-TBV-User-Timezone-Id': moment.tz.guess()
  }}
}
